<div class="record-floor-plan-section">
  <div class="record-floor-plan-btn"><span class="floorplan-icon floorplan-img"></span><span>ADD FLOOR PLAN</span></div>
</div>
